/**
 * Defers LimeSpot/personalizer storefront script until after LCP / idle.
 * Config (window.LimeSpot) is set by the Liquid snippet before this runs.
 */
(function () {
  const SCRIPT_SRC =
    'https://edge.personalizer.io/storefront/2.0.0/js/shopify/storefront.min.js?key=s4u2n-gz1dnw6no2kya1rur1h1uow-estnl&shop=qmmsug-we.myshopify.com';

  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;

  const inject = () => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.defer = true;
    document.head.appendChild(script);
  };

  const schedule = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(inject, { timeout: 4000 });
      return;
    }
    window.setTimeout(inject, 2500);
  };

  if (document.readyState === 'complete') {
    schedule();
    return;
  }

  window.addEventListener('load', schedule, { once: true });
})();
